import { Chip, Grid, IconButton, Popover, Tooltip, Typography } from "@mui/material";
import { BtnAddOnTable, BtnEditOnTable, BtnViewOnTable } from "components/Button/ButtonTable";
import DataGrid, { PaginationInterface, initRows } from "components/DataGrid";
import { FilterFieldInterface } from "components/DataGrid/DataGridProps";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { FnAxios, FnDialog } from "utilities/utilities";
import InfoIcon from '@mui/icons-material/Info';

import { EnumStatus } from "../AdminUser/Role/RoleList";
import { GetMenuPermission } from "utilities/SystemFunction";

const Indicator = () => {
    const DialogFn = FnDialog();
    const AxiosFn = FnAxios();
    const navigate = useNavigate();
    const location = useLocation();
    const [loadingTable, setLoadingTable] = useState(false);
    const [arrYear, setArrYear] = useState([]);
    const [sUpdateName, setUpdateName] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "sUpdateDate",
        sSortDirection: "desc"
    });


    const [isPermission, setPermission] = useState<boolean>(false); // Permission

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);
    }, []);


    const getFormInitial = () => {
        AxiosFn.Post(`Indicator/GetFormInitial`, {}, (result) => {
            setArrYear(result.objResult?.lstYear);
        });
    }

    const getTable = (p: PaginationInterface) => {
        setLoadingTable(true);
        let param = {
            ...p,
        }

        AxiosFn.Post(`Indicator/GetTableIndicator`, param, (result) => {
            setLoadingTable(false);
            setDataRow({
                ...p,
                arrRows: result.lstDataIndicator ?? [],
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
        });
    };

    const handleEdit = (sID: string, item: any) => {
        navigate(`/indicatorform?sID=${encodeURI(sID)}&nYear=${item.nYear}`);
    }

    const handleDelete = (e) => {
        let param = {
            lstID: e,
            nType: 1,
            sLocation: location.pathname
        }

        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            AxiosFn.Post(`Indicator/OnDelete`, param, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("ลบสำเร็จ", () => {
                        getTable(dataRow);
                    });
                }
            });
        });
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleViewInfo = (e) => {
        setUpdateName(e.sUpdateName);//sUpdateName
    }

    const dataColumn: any = [
        {
            renderHeader: (item) => (
                <BtnAddOnTable
                    id={"addIndicatorYear"}
                    onClick={() => {
                        navigate("/indicatorform");
                    }}
                    txt={"Add"}
                    IsDisabled={!isPermission}
                />
            ),
            field: "ปุ่ม (เพิ่ม/แก้ไข)",
            align: "center",
            type: "actions",
            resizable: false,
            sortable: false,
            width: 60,
            flex: 1,
            getActions: (item) => {
                return [
                    <>
                        {isPermission ? (
                            <BtnEditOnTable
                                key={item.row.sID}
                                id={"editIndicatorYear"}
                                txt={"Edit"} //Edit
                                onClick={() => { handleEdit(item.row.sFormID, item.row) }}
                            />
                        ) : (
                            <BtnViewOnTable
                                key={item.row.sID}
                                id="btnView"
                                onClick={() => { handleEdit(item.row.sFormID, item.row) }}
                            />
                        )}
                    </>
                ];
            },
        },
        {
            field: 'nYear',
            headerName: 'ปี',
            headerAlign: 'center',
            minWidth: 517,
            sortable: false,
            align: "center",
            flex: 1,
        },
        {
            field: 'sUpdateDate',
            headerName: 'แก้ไขล่าสุด',
            headerAlign: 'center',
            align: 'center',
            minWidth: 250,
            editable: false,
            flex: 1,
            renderCell: (item) => {
                return (
                    <>
                        <Grid sx={{ mr: "4px" }}>
                            {item.row.sUpdateDate}
                        </Grid>
                        <IconButton size="small"
                            onClick={(e) => { handleClick(e); handleViewInfo(item.row); }}
                        >
                            <InfoIcon
                                style={{ color: "#6e130d", cursor: "pointer" }}
                            />
                        </IconButton>
                    </>
                )
            }
        },
        {
            field: 'isActive',
            headerName: 'สถานะ',
            headerAlign: 'center',
            align: 'center',
            minWidth: 230,
            editable: false,
            flex: 1,
            renderCell: (item) => {
                return (
                    <>
                        {EnumStatus.Active == item.row.isActive &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "rgb(22 187 68)",
                                        backgroundColor: "rgb(231 255 237)",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>
                        }
                        {EnumStatus.isActive == item.row.isActive &&
                            <Tooltip title={item.row.sStatus}>
                                <Chip
                                    size="medium"
                                    label={item.row.sStatus}
                                    style={{
                                        color: "#f1416c",
                                        backgroundColor: "#fff5f8",
                                        margin: "0.2rem",
                                        fontSize: "0.8rem"
                                    }}
                                />
                            </Tooltip>

                        }
                    </>
                )
            }
        },
    ];

    //Filter Search
    const filter: FilterFieldInterface[] = [
        { sTypeFilterMode: "multiselect", sLabel: "ปี", sFieldName: "lstYear", optionSelect: arrYear, nGridLG: 3, nGridMD: 3, nGridSM: 3, nGridXS: 12 },
        { sTypeFilterMode: "date", sLabel: "วันที่แก้ไขข้อมูล(เริ่ม)", sFieldName: "sUpdateDateStart", nGridLG: 3, nGridMD: 3, nGridSM: 3, nGridXS: 12 },
        { sTypeFilterMode: "date", sLabel: "วันที่แก้ไขข้อมูล(สิ้นสุด)", sFieldName: "sUpdateDateEnd", nGridLG: 3, nGridMD: 3, nGridSM: 3, nGridXS: 12 },
        {
            sTypeFilterMode: "select", sLabel: "สถานะ", sFieldName: "isActive",
            optionSelect: [
                {

                    label: "ใช้งาน",
                    value: "1"
                },
                {

                    label: "ไม่ใช้งาน",
                    value: "0"
                },

            ],
            nGridLG: 2, nGridMD: 2, nGridSM: 2, nGridXS: 12
        },
    ];

    useEffect(() => {
        getFormInitial();
        getTable(dataRow);
    }, []);

    return (
        <>
            <Grid item xs={12}>
                <DataGrid
                    sTableID='tableIndicatorForm'
                    columns={dataColumn}
                    rows={dataRow}
                    modeFilter={1}
                    isLoading={loadingTable}
                    onLoadData={getTable}
                    isShowCheckBox={isPermission}
                    filterField={filter}
                    onDelete={handleDelete}
                    onRowSelectable={(p) => p.row.isCanDelete}
                />
            </Grid>

            {/* pop over */}
            <Popover
                id={`sUpdateNameHoliday`}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <Typography sx={{ p: 2 }}>{sUpdateName}</Typography>
            </Popover>
        </>
    );
}

export default Indicator;